
import BackIcon from '~/assets/icons/back-arrow.svg?inline'
import LazyHydrate from 'vue-lazy-hydration'

export default {
  name: 'cart-layout',
  components: {
    LazyHydrate,
    BackIcon,
    RPHToastContainer: () => import('rph/organisms/RPHToastContainer/index.vue'),
  },
  data() {
    return {
      backNavigationMap: {
        '/delivery-reservation': '/cart?type=pickup',
        '/pickup-checkout': '/delivery-reservation',
        '/delivery-checkout': '/checkout/pharmacy-list',
        '/checkout/pharmacy-list': '/cart?type=delivery',
        '/checkout/address': '/cart?type=delivery',
      },
      information: {
        '/delivery-checkout': {
          title: 'Оформление заказа',
          subtitle: 'Шаг 3 из 3',
        },
        '/checkout/pharmacy-list': {
          title: 'Тип доставки',
          subtitle: 'Шаг 2 из 3',
        },
        '/checkout/address': {
          title: 'Адрес доставки',
          subtitle: 'Шаг 1 из 3',
        },
      },
    }
  },
  methods: {
    getBackPath() {
      const { path, query } = this.$route

      if (path === '/checkout/pharmacy-list' && query.address === 'exist') {
        return '/cart?type=delivery'
      }

      const matchedPath = Object.keys(this.backNavigationMap).find((routePath) =>
        path.startsWith(routePath),
      )
      return this.backNavigationMap[matchedPath] || '/'
    },
    goBack() {
      const backPath = this.getBackPath()
      if (backPath === null) {
        if (process.client) {
          this.$router.back()
        }
      } else {
        this.$router.push(backPath)
      }
    },
  },
  computed: {
    currentTitle() {
      const currentPath = this.$route.path
      return this.information[currentPath]?.title || ''
    },
    currentSubTitle() {
      const currentPath = this.$route.path
      return this.information[currentPath]?.subtitle || ''
    },
  },
}
